/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramCategoryControllerGetTreeQueryResponse,
  TelegramCategoryControllerGetTreeQueryParams,
} from '../../types/TelegramCategoryControllerGetTree.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramCategoryGetTree } from '../../methods/telegramCategoryGetTree.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramCategoryGetTreeQueryKey = (params?: TelegramCategoryControllerGetTreeQueryParams) =>
  [{ url: '/api/telegram/category/tree' }, ...(params ? [params] : [])] as const;

export type TelegramCategoryGetTreeQueryKey = ReturnType<typeof telegramCategoryGetTreeQueryKey>;

export function telegramCategoryGetTreeQueryOptions(
  params?: TelegramCategoryControllerGetTreeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramCategoryGetTreeQueryKey(params);
  return queryOptions<
    TelegramCategoryControllerGetTreeQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramCategoryControllerGetTreeQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramCategoryGetTree(params, config);
    },
  });
}

/**
 * {@link /api/telegram/category/tree}
 */
export function useTelegramCategoryGetTree<
  TData = TelegramCategoryControllerGetTreeQueryResponse,
  TQueryData = TelegramCategoryControllerGetTreeQueryResponse,
  TQueryKey extends QueryKey = TelegramCategoryGetTreeQueryKey,
>(
  params?: TelegramCategoryControllerGetTreeQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramCategoryControllerGetTreeQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramCategoryGetTreeQueryKey(params);

  const query = useQuery(
    {
      ...telegramCategoryGetTreeQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
